<template>
  <div class="flex flex-row text-4xl w-full papsi-gap">
    <!-- Month Dropdown -->
    <div class="relative">
      <div 
        class="relative flex border border-grey py-4 px-6  bg-white rounded-xl cursor-pointer items-center justify-between month" 
        style="width: 20rem;"
        @click="toggleDropdown('month')"
        :class="{ 'active': open_dropdown === 'month' }"
        aria-label="Month Selector"
      >
      <span :class="{'text-grey-dark': !selected_month}">
        {{ selected_month ? months[selected_month - 1] : 'Month' }}
      </span>

        <img :src="getIcon('dropdown')" alt="Dropdown Arrow" class="arrow-icon" />
      </div>
      <ul v-if="open_dropdown === 'month'" class="absolute z-10 bg-white border rounded-xl overflow-y-auto w-full papsi-menu">
        <li
          v-for="(month, index) in months"
          :key="index"
          @click="selectMonth(index + 1)"
        >
          {{ month }}
        </li>
      </ul>
    </div>

    <!-- Day Dropdown -->
    <div class="relative">
      <div 
        class="relative flex border border-grey py-4 px-6  bg-white rounded-xl cursor-pointer items-center justify-between day" 
        style="width: 14rem;"
        @click="toggleDropdown('day')"
        :class="{ 'active': open_dropdown === 'day' }"
        aria-label="Day Selector"
      >
        <span :class="{'text-grey-dark': !selected_day}">
          {{ selected_day || 'Day' }}
        </span>
        
        <img :src="getIcon('dropdown')" alt="Dropdown Arrow" class="arrow-icon" />
      </div>

      <ul v-if="open_dropdown === 'day'" class="absolute z-10 bg-white border rounded-xl overflow-y-auto w-full papsi-menu">
        <li
          v-for="day in days"
          :key="day"
          @click="selectDay(day)"
        >
          {{ day }}
        </li>
      </ul>
    </div>

    <!-- Year Dropdown -->
    <div class="relative">
      <div 
        class="relative flex border border-grey py-4 px-6  bg-white rounded-xl cursor-pointer items-center justify-between year" 
        style="width: 17rem;"
        @click="toggleDropdown('year')"
        :class="{ 'active': open_dropdown === 'year' }"
        aria-label="Year Selector"
      >
        <span :class="{'text-grey-dark': !selected_year}">
          {{ selected_year || 'Year' }}
        </span>
       
        <img :src="getIcon('dropdown')" alt="Dropdown Arrow" class="arrow-icon" />
      </div>
      <ul v-if="open_dropdown === 'year'" class="absolute z-10 bg-white border rounded-xl overflow-y-auto w-full papsi-menu">
        <li
          v-for="year in years"
          :key="year"
          @click="selectYear(year)"
        >
          {{ year }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import mixin from '@/mixins/controls.js';

export default {
  name: 'v-datepicker',
  mixins: [mixin],
  data() {
    return {
      months: [
        "January", "February", "March", "April", "May", "June", 
        "July", "August", "September", "October", "November", "December"
      ],
      days: [],
      years: [],
      selected_month: "",
      selected_day: "",
      selected_year: "",
      open_dropdown: null, // Tracks which dropdown is open
    };
  },
  created() {
    this.populateYears();
    this.days = Array.from({ length: 31 }, (_, i) => i + 1); // Default to 1–31
  },
  methods: {
    populateYears() {
      const currentYear = new Date().getFullYear();
      const startYear = currentYear - 18;
      this.years = Array.from({ length: 120 }, (_, i) => startYear - i);
    },
    updateDays() {
      const daysInMonth = this.selected_month
        ? new Date(this.selected_year || 2000, this.selected_month, 0).getDate()
        : 31; // Default to 31 days if no month is selected

      this.days = Array.from({ length: daysInMonth }, (_, i) => i + 1);
    },
    toggleDropdown(type) {
      this.open_dropdown = this.open_dropdown === type ? null : type;
    },
    selectMonth(month) {
      this.selected_month = month;
      this.updateDays();
      this.open_dropdown = null;
      this.emitDate();
    },
    selectDay(day) {
      this.selected_day = day;
      this.open_dropdown = null;
      this.emitDate();
    },
    selectYear(year) {
      this.selected_year = year;
      this.updateDays();
      this.open_dropdown = null;
      this.emitDate();
    },
    emitDate() {
      // Emit an event with the selected values
      this.$emit('update:date', {
        year: this.selected_year,
        month: this.selected_month,
        day: this.selected_day,
      });
    },

  },
};
</script>

<style scoped>

.papsi-menu {
  top: 100%;
  left: 0;
  max-height: 30rem;
  list-style: none;
}

.papsi-menu li {
  padding: 1rem 0;
  white-space: nowrap;
}


.papsi-gap {
  gap: 2rem;
}

@media (min-width: 2500px) {
    .month {
      width: 29rem !important;
    }
    .day {
      width: 21rem !important;
    }
    .year {
      width: 21rem !important;
    }
    .papsi-menu {
      max-height: 45rem !important;   
    }

    
   
}

</style>
